export default {"src":"/_next/static/media/icon-ig-button.38cd1738.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};